import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Grid,
  Collapse,
} from "@mui/material";
import AttendanceInfoViewModal from "./AttendanceSwipeViewModal";
import DialogForm from "@/components/modal/DialogForm";
import empty_state_regularisation from "@/assets/images/attendance/empty_state_regularisation.png";
import { useTheme } from "@mui/system";
import styled from "@emotion/styled";
import moment from 'moment';
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useGetSwipeDetailsDateQuery } from "@/api/services/attendance/regularization/EmployeeRegularization";
import StatusChip from "@/components/table/chip";
dayjs.extend(duration);

const hasPunchTime = (time) => {
  if (time == null || time === "") return false;
  const normalized = String(time).trim();
  return normalized !== "" && normalized !== "00:00" && normalized !== "00:00:00";
};

const isImproperPunch = (inTime, outTime) => {
  const hasIn = hasPunchTime(inTime);
  const hasOut = hasPunchTime(outTime);
  return hasIn !== hasOut;
};

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.BudgieThemeColor.Primary[100],
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: "16px",
  textAlign: "left",
}));

const AttendanceInfoModal = ({
  attendanceInfotoggleOpen,
  attendanceInfotoggleClose,
  empId,
  scroll,
  date,
  shift,
  InfoData,
  title,
}) => {
  const theme = useTheme();
  const [attendanceInfoViewModal, setAttendanceInfoView] = React.useState(false);
  const [swipeTime, setSwipeTime] = useState(null);


  const selectedDate = dayjs(date).format("YYYY-MM-DD");


 const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));
  const userDetails = localStorageData?.userDetails || {};
  // const empID = empId ?? userDetails?.empId;

  const { data: quickAddList = [], refetch } = useGetSwipeDetailsDateQuery(
    { empID: empId, Date: selectedDate }
  
  );
  const rowData = quickAddList?.data || [];
  // Find the data for selected date
  const selectedInfo = InfoData.find(
    (item) => item.attendanceDate === selectedDate
  );

  const showImproperPunchStatus = isImproperPunch(
    selectedInfo?.inTime,
    selectedInfo?.outTime
  );



  const formatDeviceName = (deviceName) =>
  deviceName
    .toLowerCase()               
    .replace(/_/g, " ")          
    .replace(/\b\w/g, (c) => c.toUpperCase()); 


  const transformedData = rowData.map((item) => [
    // dayjs(item.LogDateTime).format('YYYY-MM-DD'),
    moment(item.LogDateTime).format("DD-MM-YYYY"),
    dayjs(item.LogDateTime).format('HH:mm:ss'),
    formatDeviceName(item.DeviceName),
    item.Direction?.toUpperCase() || "",
  ]);

  const calculateLateInHrs = (sessionStart, firstIn) => {
    const sessionStartTime = moment(sessionStart, "HH:mm");
    const firstInTime = moment(firstIn, "HH:mm");
    if (firstInTime.isAfter(sessionStartTime)) {
      const diffMinutes = firstInTime.diff(sessionStartTime, "minutes");
      const hours = Math.floor(diffMinutes / 60);
      const minutes = diffMinutes % 60;
      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    }
    return "00:00";
  };

  const calculateExcessInHrs = (firstIn, sessionStart) => {
    const firstInTime = moment(firstIn, "HH:mm");
    const sessionStartTime = moment(sessionStart, "HH:mm");
    if (firstInTime.isBefore(sessionStartTime)) {
      const diffMinutes = sessionStartTime.diff(firstInTime, "minutes");
      const hours = Math.floor(diffMinutes / 60);
      const minutes = diffMinutes % 60;
      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    }
    return "00:00";
  };

  const openAttendanceInfoView = () => {
    setAttendanceInfoView(true);
  };
  const closeAttendanceInfoView = () => {
    setAttendanceInfoView(false);
  };
  const [swipeType, setSwipeType] = React.useState("");
  const [visible, setVisible] = React.useState(true);
  const handleOpenAttendanceInfoView = (type, time) => {
    setSwipeType(type);
    setSwipeTime(time);
    openAttendanceInfoView();
  };

  const toggleVisibility = () => {
    setVisible((prevVisible) => !prevVisible);
  };

  // Render a styled header with a close button and date
  const renderHeader = () => (
    <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
      <Typography variant="h6">{date} ( {new Date(date).toLocaleDateString('en-US', { weekday: 'long' })} )</Typography>
      {/* <Button onClick={attendanceInfotoggleClose}>Close</Button> */}
    </Box>
  );

  const renderTable = (headers, rows) => (
    <TableContainer sx={{ mt: 2 }}>
      <Table>
        <StyledTableHead>
          <TableRow>
            {headers.map((header, index) => (
              <StyledTableCell key={index} sx={{ fontWeight: "bold" }}>
                {header}
              </StyledTableCell>
            ))}
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              {row.map((cell, i) => (
                <StyledTableCell key={i}>{cell}</StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const sessionDetails = InfoData.filter(item => moment(item.attendanceDate).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD"))
    .flatMap(item => {
      return [
        ["Session 1", item.session_1_shift, item.session1_firstIn, item.session1_lastOut, item.session1_lateIn, item.session1_excessIn, item.session1_earlyOut],
        ["Session 2", item.session_2_shift, item.session2_firstIn, item.session2_lastOut, item.session2_lateIn, item.session2_excessIn, item.session2_earlyOut],
      ];
    });

  const renderDetailsBox = () => (
    <Collapse in={visible}>
      {visible && (
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          mt={2}
          p={2}
          sx={{
            backgroundColor: theme.palette.BudgieThemeColor.Primary[100],
            borderRadius: 2,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <Typography variant="body1">Half Day Minimum Hours</Typography>
              <Typography variant="body2">
                Half day minimum hours is not fulfilled and so, 1 day(s) of LOP
                will be deducted.
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{ textAlign: "right" }}>
              <Button onClick={toggleVisibility} color="primary">
                Hide
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Collapse>
  );

  const renderEmptyState = () => (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <img src={empty_state_regularisation} alt="empty_state_regularisation" />
      <Typography variant="h6">No Records Available</Typography>
    </Box>
  );

  return (
    <DialogForm
      width="md"
      setOpen={attendanceInfotoggleClose}
      open={attendanceInfotoggleOpen}
      title={title}
      scroll={scroll || "body"}
    >
      {/* {renderHeader()} */}
      <Typography variant="h6" gutterBottom>
        Details
      </Typography>
      {["H", "OFF", "A", "WFH", "PL", "CL", "SL", "PRL", "PRIL"].includes(
        title
      ) && (
          <>
            {!visible && (
              <Button
                onClick={toggleVisibility}
                color="primary"
                sx={{ float: "right" }}
              >
                Info
              </Button>
            )}
            {renderDetailsBox()}
          </>
        )}
      <Box sx={{ p: theme.spacing(2) }}>
        <Grid container spacing={2}>
          {[
            { label: `Shift (${shift})`, value: selectedInfo?.shift },
            { label: "Biometric CITPL", value: "Attendance Scheme" },
            { label: "Processed on", value: `${date} (${new Date(date).toLocaleDateString('en-US', { weekday: 'long' })})` },
            ...(showImproperPunchStatus
              ? [
                  {
                    label: "Punch Status",
                    value: (
                      <StatusChip
                        label="Improper Punch"
                        backgroundColor="#FEF3F2"
                        dotColor="#F04438"
                        borderColor="#FECDCA"
                      />
                    ),
                  },
                ]
              : []),
          ].map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={3}>
                <Typography variant="subtitle1">{item.label}</Typography>
              </Grid>
              <Grid
                item
                xs={1}
                container
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="subtitle1">:</Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1">{item.value}</Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
      {renderTable(
        [
          "First In",
          "Last Out",
          "Total Work hrs",
          "Break Hours",
          "Actual Work hrs",
          "Shortfall hrs",
          "Excess hrs",
        ],
        InfoData
          .filter(item => dayjs(item.attendanceDate).format("DD-MM-YYYY") === dayjs(date).format("DD-MM-YYYY"))
          .map(item => [
            item.inTime || "00:00",
            item.outTime || "00:00",
            item.totalWorkHours || "00:00",
            item.breakHrs || "00:00",
            item.actualWorkHours || "00:00",
            item.shortFallHours || "00:00",
            item.excessHours || "00:00",
          ])
      )}
      {/* <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        Status Details
      </Typography>
      {renderTable(["Status", "Remarks"], [["-", "-"]])} */}
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        Session Details
      </Typography>
      {renderTable(
        ["Session", "Session timing", "First In", "Last Out", "Late In hrs", "Excess In hrs", "Early Out hrs"],
        sessionDetails
      )}
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        Swipes
      </Typography>

      {["H", "OFF", "A", "WFH", "PL", "CL", "SL", "PRL", "PRIL"].includes(title)
        ? renderEmptyState()
        : (() => {
          const filteredData = InfoData.find(
            (item) =>
              dayjs(item.attendanceDate).format("DD-MM-YYYY") ===
              dayjs(date).format("DD-MM-YYYY")
          );

          if (!filteredData) return renderEmptyState();

          const rows = [];

          // Only push In time row if not 00:00
          if (filteredData.inTime && filteredData.inTime !== "00:00") {
            rows.push([
              date,
              `${filteredData.inTime} am`,
              "HEPL CSV",
              <Button
                onClick={() =>
                  handleOpenAttendanceInfoView("In", `${filteredData.inTime} am`)
                }
                color="primary"
              >
                Info
              </Button>,
            ]);
          }

          // Only push Out time row if not 00:00
          if (filteredData.outTime && filteredData.outTime !== "00:00") {
            rows.push([
              date,
              `${filteredData.outTime} pm`,
              "HEPL CSV",
              <Button
                onClick={() =>
                  handleOpenAttendanceInfoView("Out", `${filteredData.outTime} pm`)
                }
                color="primary"
              >
                Info
              </Button>,
            ]);
          }

          return transformedData?.length ? renderTable(["Swipe Date", "Swipe Time", "Door/Address", "In/Out"], transformedData) : renderEmptyState();
        })()}

      {attendanceInfoViewModal && (
        <AttendanceInfoViewModal
          attendanceInfoViewtoggleOpen={attendanceInfoViewModal}
          attendanceInfoViewtoggleClose={closeAttendanceInfoView}
          swipeType={swipeType}
          empId={empId}
          swipeInTime={InfoData.inTime}
          swipeOutTime={InfoData.outTime}
          empName={InfoData.empName}
          swipeTime={swipeTime}
          selectedInfo={selectedInfo}
        />
      )}
    </DialogForm>
  );
};

AttendanceInfoModal.propTypes = {
  attendanceInfotoggleOpen: PropTypes.bool.isRequired,
  attendanceInfotoggleClose: PropTypes.func.isRequired,
  empId: PropTypes.string.isRequired,
  scroll: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  shift: PropTypes.string.isRequired,
  InfoData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default AttendanceInfoModal;